<template>
  <div>
    <el-dialog title="" :visible="true" width="100%" :show-close="false">
      <p>亲爱的同学： </p>
      <p>经过了一次与咨询师的咨询，我们邀请你进行反馈，以便能够帮助咨询师们总结和改善工作。  </p>
      <br>
      <Question v-for="(question,index) in filterQuestions" :question="question"
                :key="index + '' + question.num" :id="'question_' + question.num"
                v-on:listenToChildEvent="listenToChildEvent"></Question>
      <span slot="footer">
        <el-button @click="cancel" round>取 消</el-button>
        <el-button type="primary" @click="toNext" round v-preventReClick>提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Question from '../components/Question';

export default {
  components: {
    Question,
  },
  data() {
    return {
      currentPage: 1,
      arrQuestion: [
        { num: 1, type: 1, must: 1, page: 1, finish: 0, answer: null, errorMessage: '', mustFillMessage: '该题未完成', title: '这次会谈，我认为是：（1-7打分，7分非常符合）：', subQuestionCount: 5, lowTitle: ['无价值','肤浅','紧张','空虚','虚弱'], highTitle: ['有价值','有深度','放松','详尽','有力量'], arrScore: [1,2,3,4,5,6,7] },
        { num: 2, type: 1, must: 1, page: 1, finish: 0, answer: null, errorMessage: '', mustFillMessage: '该题未完成', title: '这次会谈结束后，我的情绪是：（非常不符合为1分，非常符合为7分）：', subQuestionCount: 5, lowTitle: ['沮丧','躁动','无所适从','害怕','敌意'], highTitle: ['愉快','平静','内心充实','自信','友善'], arrScore: [1,2,3,4,5,6,7] },
        { num: 3, type: 6, must: 1, page: 1, finish: 0, answer: null,  errorMessage: '', mustFillMessage: '请填写', title: '我对本次约谈的咨询师，还有话想表达：' },
      ],
    };
  },
  computed:{
    filterQuestions() {
      return this.arrQuestion.filter(question => question.page === this.currentPage)
    }
  },
  mounted() {
    document.title = '反馈打分';
  },
  methods: {
    cancel(){
      this.$emit('cancel-addFeedback');
    },
    //答题
    listenToChildEvent(num, answer, question){
      this.arrQuestion[num - 1] = question
    },
    // 下一题或下一页事件，并提交
    toNext(){
      if(this.confirmMust()){
        //提交
        this.submitSave(this.currentPage);
      }
    },
    confirmMust() {
      for (let question of this.arrQuestion) {
        question.errorMessage = ''
        if (question.page === this.currentPage && question.must === 1 && question.finish === 0) {
          question.errorMessage = question.mustFillMessage
          this.scrollToSection('question_' + question.num)
          return false
        }
      }
      return true
    },
    //跳转到指定位置
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId)
      if (section) {
        const offsetTop = section.offsetTop
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    },
    // 数据提交
    submitSave(page){
      //转成字符串
      let submitdata = '';
      let answerArr = []
      for (let question of this.arrQuestion) {
        answerArr.push(question.num + '$' + question.answer + '}')
      }
      submitdata = answerArr.join('').slice(0, -1)
      //提交
      this.$emit('save-addFeedback',submitdata);
    },
  },
};
</script>

<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}
>>> .el-dialog__header {
  padding: 0;
}
>>> .el-dialog__body {
  overflow-y: auto;
  height: calc(100vh - 50px);
}

</style>
